// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0bfc014f","498":"be5ec9fe","545":"85d67268"}[chunkId] + ".chunk.js";
};